import React, { useEffect, useState } from "react";
import * as api from "../../api/index.js";
import {
  Button,
  Typography,
  Box,
  IconButton,
  Container,
  CircularProgress,
  Fade,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  MenuItem,
  Tabs,
  Tab,
  Chip,
  Paper,
  makeStyles,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import RefreshIcon from "@material-ui/icons/Refresh";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ReceiptIcon from "@material-ui/icons/Receipt";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100%",
    background:
      "linear-gradient(180deg, rgba(255,247,239,0.6) 0%, rgba(255,255,255,1) 22%)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2.25),
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  headerTitle: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#111827",
  },
  headerSubtitle: {
    fontSize: "14px",
    color: "#6b7280",
    marginTop: theme.spacing(0.75),
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  filterCard: {
    width: "100%",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 18,
    border: "1px solid rgba(239, 127, 26, 0.15)",
    boxShadow: "0 14px 32px rgba(15, 23, 42, 0.06)",
    background: "rgba(255, 255, 255, 0.96)",
    backdropFilter: "blur(10px)",
  },
  filterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing(1),
    },
  },
  filterGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    alignItems: "flex-end",
  },
  filterField: {
    flex: "1 1 220px",
    minWidth: 190,
    [theme.breakpoints.down("sm")]: {
      flexBasis: "100%",
      minWidth: "100%",
    },
  },
  filterActions: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    alignItems: "center",
    justifyContent: "flex-end",
    alignSelf: "end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "stretch",
      width: "100%",
    },
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: "13px",
    fontWeight: 700,
    color: "#374151",
    marginBottom: theme.spacing(1),
  },
  dateRangeBox: {
    display: "flex",
    flexWrap: "nowrap",
    gap: theme.spacing(1),
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },
  dateField: {
    flex: "1 1 190px",
    minWidth: 190,
  },
  helperBanner: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 12,
    border: "1px solid rgba(239, 127, 26, 0.2)",
    background: "#fff7ef",
    color: "#9a3412",
    fontSize: "13px",
    fontWeight: 600,
  },
  appliedFiltersRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  },
  appliedFilterChip: {
    backgroundColor: "#f9fafb",
    color: "#374151",
    border: "1px solid rgba(15, 23, 42, 0.08)",
  },
  summaryRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(2),
  },
  summaryCard: {
    flex: "1 1 180px",
    minWidth: 180,
    padding: theme.spacing(1.75, 2),
    borderRadius: 14,
    background: "linear-gradient(135deg, rgba(239,127,26,0.08), rgba(255,255,255,0.96))",
    border: "1px solid rgba(239, 127, 26, 0.14)",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
  },
  summaryMeta: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  summaryLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  summaryValue: {
    fontSize: 24,
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1.2,
  },
  summaryIcon: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(239, 127, 26, 0.12)",
    color: "#ef7f1a",
  },
  tabsContainer: {
    width: "100%",
    borderRadius: 18,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    boxShadow: "0 14px 32px rgba(15, 23, 42, 0.06)",
    background: "#ffffff",
    overflow: "hidden",
  },
  tabs: {
    backgroundColor: "#fff7ef",
    borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
    "& .MuiTabs-indicator": {
      backgroundColor: "#ef7f1a",
      height: 3,
    },
    "& .MuiTab-root": {
      fontWeight: 600,
      textTransform: "none",
      fontSize: "15px",
      minWidth: 160,
      "&.Mui-selected": {
        color: "#ef7f1a",
      },
    },
  },
  tabPanel: {
    padding: theme.spacing(2),
  },
  groupCard: {
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
    overflow: "hidden",
  },
  groupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "linear-gradient(135deg, rgba(239,127,26,0.12), rgba(255,255,255,0.96))",
    padding: theme.spacing(2, 2.5),
    borderBottom: "1px solid rgba(239, 127, 26, 0.15)",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  groupHeaderText: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  groupTitle: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#111827",
  },
  groupSubtitle: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#6b7280",
  },
  statusChip: {
    fontWeight: 700,
    fontSize: "13px",
    minWidth: 110,
  },
  successChip: {
    backgroundColor: "#d1fae5",
    color: "#047857",
  },
  pendingChip: {
    backgroundColor: "#fef3c7",
    color: "#b45309",
  },
  tableContainer: {
    borderRadius: "0 0 12px 12px",
  },
  table: {
    "& thead th": {
      backgroundColor: "#f9fafb",
      fontWeight: 700,
      fontSize: "13px",
      color: "#374151",
      borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
      padding: "12px 16px",
      textAlign: "center",
      whiteSpace: "nowrap",
    },
    "& tbody tr": {
      borderBottom: "1px solid rgba(15, 23, 42, 0.04)",
      "&:hover": {
        backgroundColor: "#f9fafb",
      },
    },
    "& tbody td": {
      fontSize: "13px",
      padding: "12px 16px",
      textAlign: "center",
      color: "#374151",
    },
  },
  noData: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#9ca3af",
  },
  noDataTitle: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#374151",
    marginBottom: theme.spacing(0.75),
  },
  noDataText: {
    fontSize: "13px",
    color: "#6b7280",
  },
  paginationBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 16,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    background: "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(239,127,26,0.04))",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
  },
  paginationButton: {
    fontWeight: 600,
    textTransform: "none",
    fontSize: "13px",
    padding: theme.spacing(0.75, 2),
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "rgba(239, 127, 26, 0.1)",
    },
  },
  paginationText: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#374151",
    minWidth: 200,
    textAlign: "center",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

const getTodayDate = () => new Date(new Date().setHours(0, 0, 0, 0));

const formatDateForApi = (value) => {
  if (!value) return "";
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const buildDefaultFilters = () => ({
  startDate: getTodayDate(),
  endDate: getTodayDate(),
  invoiceNumber: "",
});

const areFiltersEqual = (left, right) =>
  formatDateForApi(left.startDate) === formatDateForApi(right.startDate) &&
  formatDateForApi(left.endDate) === formatDateForApi(right.endDate) &&
  left.invoiceNumber === right.invoiceNumber;

const formatDateLabel = (value) => {
  if (!value) return "Any date";
  return new Date(value).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default function QrScanReport() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [overallStats, setOverallStats] = useState({
    total: 0,
    scanned: 0,
    pending: 0,
  });
  const [invoiceStats, setInvoiceStats] = useState({
    successInvoices: 0,
    pendingInvoices: 0,
  });
  const [filters, setFilters] = useState(() => buildDefaultFilters());
  const [appliedFilters, setAppliedFilters] = useState(() => buildDefaultFilters());
  const [hasPendingFilterChanges, setHasPendingFilterChanges] = useState(false);
  const [reportBuckets, setReportBuckets] = useState({
    SUCCESS: {
      rows: [],
      loaded: false,
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 10,
        hasNextPage: false,
        hasPrevPage: false,
      },
    },
    PENDING: {
      rows: [],
      loaded: false,
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 10,
        hasNextPage: false,
        hasPrevPage: false,
      },
    },
  });

  const activeStatus = tabValue === 0 ? "SUCCESS" : "PENDING";
  const activeBucket = reportBuckets[activeStatus];

  const fetchReport = async ({
    status = activeStatus,
    pageNum = 1,
    activeFilters = appliedFilters,
  } = {}) => {
    try {
      setLoading(true);
      const response = await api.fetchQrScanReport({
        startDate: formatDateForApi(activeFilters.startDate),
        endDate: formatDateForApi(activeFilters.endDate),
        invoiceNumber: activeFilters.invoiceNumber,
        status,
        page: pageNum,
        limit: 10,
      });

      const data = response.data || {};
      const nextPagination = data.pagination || {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 10,
        hasNextPage: false,
        hasPrevPage: false,
      };

      setReportBuckets((prev) => ({
        ...prev,
        [status]: {
          rows: data.data || [],
          pagination: nextPagination,
          loaded: true,
        },
      }));
      setOverallStats(data.overallStats || { total: 0, scanned: 0, pending: 0 });
      setInvoiceStats(data.invoiceStats || { successInvoices: 0, pendingInvoices: 0 });
    } catch (error) {
      console.error("Failed to load QR scan report", error);
      setReportBuckets((prev) => ({
        ...prev,
        [status]: {
          rows: [],
          loaded: true,
          pagination: {
            currentPage: 1,
            totalPages: 1,
            totalRecords: 0,
            recordsPerPage: 10,
            hasNextPage: false,
            hasPrevPage: false,
          },
        },
      }));
      setOverallStats({ total: 0, scanned: 0, pending: 0 });
      setInvoiceStats({ successInvoices: 0, pendingInvoices: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport({ status: "SUCCESS", pageNum: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setHasPendingFilterChanges(!areFiltersEqual(filters, appliedFilters));
  }, [filters, appliedFilters]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= activeBucket.pagination.totalPages) {
      fetchReport({ status: activeStatus, pageNum: newPage, activeFilters: appliedFilters });
    }
  };

  const handleApplyFilters = () => {
    setAppliedFilters(filters);
    setTabValue(0);
    setReportBuckets({
      SUCCESS: {
        rows: [],
        loaded: false,
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalRecords: 0,
          recordsPerPage: 10,
          hasNextPage: false,
          hasPrevPage: false,
        },
      },
      PENDING: {
        rows: [],
        loaded: false,
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalRecords: 0,
          recordsPerPage: 10,
          hasNextPage: false,
          hasPrevPage: false,
        },
      },
    });
    fetchReport({ status: "SUCCESS", pageNum: 1, activeFilters: filters });
  };

  const handleResetFilters = () => {
    const defaultFilters = buildDefaultFilters();
    setFilters(defaultFilters);
    setAppliedFilters(defaultFilters);
    setTabValue(0);
    setReportBuckets({
      SUCCESS: {
        rows: [],
        loaded: false,
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalRecords: 0,
          recordsPerPage: 10,
          hasNextPage: false,
          hasPrevPage: false,
        },
      },
      PENDING: {
        rows: [],
        loaded: false,
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalRecords: 0,
          recordsPerPage: 10,
          hasNextPage: false,
          hasPrevPage: false,
        },
      },
    });
    fetchReport({ status: "SUCCESS", pageNum: 1, activeFilters: defaultFilters });
  };

  const handleRefresh = () => {
    fetchReport({
      status: activeStatus,
      pageNum: activeBucket.pagination.currentPage,
      activeFilters: appliedFilters,
    });
  };

  const updateFilter = (field, value) => {
    setFilters((prev) => {
      const next = { ...prev, [field]: value };

      if (
        field === "startDate" &&
        value &&
        next.endDate &&
        new Date(value) > new Date(next.endDate)
      ) {
        next.endDate = value;
      }

      if (
        field === "endDate" &&
        value &&
        next.startDate &&
        new Date(value) < new Date(next.startDate)
      ) {
        next.startDate = value;
      }

      return next;
    });
  };

  const getStationSummary = (tokens = [], status) => {
    const filtered = tokens.filter((token) => token.scanStatus === status);
    return [...new Set(filtered.map((token) => token.station).filter(Boolean))].join(", ") || "-";
  };

  const handleTabChange = (_event, nextTab) => {
    setTabValue(nextTab);
    const nextStatus = nextTab === 0 ? "SUCCESS" : "PENDING";
    if (!reportBuckets[nextStatus].loaded) {
      fetchReport({ status: nextStatus, pageNum: 1, activeFilters: appliedFilters });
    }
  };

  const renderStatusTable = (status) => {
    const bucket = reportBuckets[status];
    const rows = bucket.rows || [];

    return (
      <TableContainer component={Paper} elevation={0} className={classes.tableContainer}>
        <Table size="small" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Invoice Number</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Stations</TableCell>
              <TableCell>{status === "SUCCESS" ? "Success Scan" : "Pending Scan"}</TableCell>
              <TableCell>Total Scan </TableCell>
              <TableCell>Latest Scan</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <Box className={classes.noData}>
                    <Typography className={classes.noDataTitle}>
                      No {status === "SUCCESS" ? "successful" : "pending"} scans found
                    </Typography>
                    <Typography className={classes.noDataText}>
                      Try adjusting the filters and click Apply Filters to refresh the report.
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}

            {rows.map((invoice) => (
              <TableRow key={invoice._id}>
                <TableCell>{invoice.invoiceNumber || "-"}</TableCell>
                <TableCell>
                  {invoice.createdAt ? new Date(invoice.createdAt).toLocaleDateString("en-IN") : "-"}
                </TableCell>
                <TableCell>{getStationSummary(invoice.tokens, status)}</TableCell>
                <TableCell>{status === "SUCCESS" ? invoice.scannedCount : invoice.pendingCount}</TableCell>
                <TableCell>{invoice.totalTokens ?? 0}</TableCell>
                <TableCell>
                  {invoice.latestScannedAt
                    ? new Date(invoice.latestScannedAt).toLocaleString("en-IN")
                    : "-"}
                </TableCell>
                <TableCell>
                  <Chip
                    label={status}
                    size="small"
                    className={status === "SUCCESS" ? classes.successChip : classes.pendingChip}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          {bucket.pagination.totalRecords > 0 && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10]}
                  colSpan={7}
                  count={bucket.pagination.totalRecords || 0}
                  rowsPerPage={bucket.pagination.recordsPerPage || 10}
                  page={Math.max(0, (bucket.pagination.currentPage || 1) - 1)}
                  onPageChange={(_event, newPage) => handlePageChange(newPage + 1)}
                  onRowsPerPageChange={() => {}}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    );
  };

  return (
    <Box className={classes.root}>
      <Container maxWidth="lg" style={{ paddingTop: "24px", paddingBottom: "24px" }}>
        <Fade in timeout={600}>
          <Box>
            <Box className={classes.header}>
              <Box>
                <Typography className={classes.headerTitle}>QR Scan Report</Typography>
                <Typography className={classes.headerSubtitle}>
                  Filter invoice-wise QR activity with a cleaner date range and quick reset.
                </Typography>
              </Box>
              <Box className={classes.headerActions}>
                <Chip
                  label={`${
                    activeStatus === "SUCCESS"
                      ? invoiceStats.successInvoices || 0
                      : invoiceStats.pendingInvoices || 0
                  } invoices`}
                  className={classes.appliedFilterChip}
                />
                <IconButton onClick={handleRefresh} disabled={loading} style={{ color: "#ef7f1a" }}>
                  <RefreshIcon />
                </IconButton>
              </Box>
            </Box>

            <Box className={classes.filterCard}>
              <Box className={classes.filterHeader}>
                <Box>
                  <Typography style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
                    Filters
                  </Typography>
                  <Typography style={{ fontSize: "13px", color: "#6b7280", marginTop: 4 }}>
                    Today is selected by default. Change any value and apply to refresh the report.
                  </Typography>
                </Box>
              </Box>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Box className={classes.filterGrid}>
                  <Box className={classes.filterField}>
                    <Typography className={classes.sectionLabel}>
                      <ReceiptIcon fontSize="small" />
                      Invoice Search
                    </Typography>
                    <TextField
                      label="Invoice Number"
                      placeholder="Search invoice number"
                      value={filters.invoiceNumber}
                      onChange={(e) => updateFilter("invoiceNumber", e.target.value)}
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  </Box>

                  <Box className={classes.filterField}>
                    <Typography className={classes.sectionLabel}>
                      <DateRangeIcon fontSize="small" />
                      Date Range
                    </Typography>
                    <Box className={classes.dateRangeBox}>
                      <KeyboardDatePicker
                        autoOk
                        inputVariant="outlined"
                        size="small"
                        label="From"
                        format="yyyy/MM/dd"
                        value={filters.startDate}
                        onChange={(date) => updateFilter("startDate", date)}
                        className={classes.dateField}
                        maxDate={filters.endDate || getTodayDate()}
                        KeyboardButtonProps={{
                          "aria-label": "select start date",
                        }}
                      />
                      <KeyboardDatePicker
                        autoOk
                        inputVariant="outlined"
                        size="small"
                        label="To"
                        format="yyyy/MM/dd"
                        value={filters.endDate}
                        onChange={(date) => updateFilter("endDate", date)}
                        className={classes.dateField}
                        minDate={filters.startDate}
                        maxDate={getTodayDate()}
                        KeyboardButtonProps={{
                          "aria-label": "select end date",
                        }}
                      />
                    </Box>
                  </Box>

                  <Box className={classes.filterActions}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#ef7f1a",
                        color: "white",
                        fontWeight: 600,
                        textTransform: "none",
                        padding: "8px 16px",
                        height: 40,
                      }}
                      onClick={handleApplyFilters}
                      disabled={loading}
                    >
                      Apply Filters
                    </Button>
                    <Button
                      variant="outlined"
                      style={{
                        color: "#ef7f1a",
                        borderColor: "rgba(239,127,26,0.45)",
                        fontWeight: 600,
                        textTransform: "none",
                        padding: "8px 16px",
                        height: 40,
                      }}
                      onClick={handleResetFilters}
                      disabled={loading}
                    >
                      Reset
                    </Button>
                  </Box>
                </Box>
              </MuiPickersUtilsProvider>

              {hasPendingFilterChanges && (
                <Box className={classes.helperBanner}>
                  Filters changed. Click Apply Filters to refresh the report data.
                </Box>
              )}

              <Box className={classes.appliedFiltersRow}>
                <Chip
                  label={`Applied date: ${formatDateLabel(appliedFilters.startDate)} to ${formatDateLabel(
                    appliedFilters.endDate
                  )}`}
                  className={classes.appliedFilterChip}
                />
                <Chip
                  label={`Invoice: ${appliedFilters.invoiceNumber || "All"}`}
                  className={classes.appliedFilterChip}
                />
              </Box>
            </Box>

            {!loading && (
              <Box className={classes.summaryRow}>
                <Box className={classes.summaryCard}>
                  <Box className={classes.summaryMeta}>
                    <Typography className={classes.summaryLabel}>Successful Scan</Typography>
                    <Box className={classes.summaryIcon}>
                      <CheckCircleIcon fontSize="small" />
                    </Box>
                  </Box>
                  <Typography className={classes.summaryValue}>{overallStats?.scanned ?? 0}</Typography>
                </Box>

                <Box className={classes.summaryCard}>
                  <Box className={classes.summaryMeta}>
                    <Typography className={classes.summaryLabel}>Pending Scan</Typography>
                    <Box className={classes.summaryIcon}>
                      <HourglassEmptyIcon fontSize="small" />
                    </Box>
                  </Box>
                  <Typography className={classes.summaryValue}>{overallStats?.pending ?? 0}</Typography>
                </Box>

                <Box className={classes.summaryCard}>
                  <Box className={classes.summaryMeta}>
                    <Typography className={classes.summaryLabel}>Total </Typography>
                    <Box className={classes.summaryIcon}>
                      <ReceiptIcon fontSize="small" />
                    </Box>
                  </Box>
                  <Typography className={classes.summaryValue}>{overallStats?.total ?? 0}</Typography>
                </Box>
              </Box>
            )}

            {loading && (
              <Box className={classes.loadingContainer}>
                <CircularProgress size={40} style={{ color: "#ef7f1a" }} />
              </Box>
            )}

            {!loading && (
              <Box className={classes.tabsContainer}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  className={classes.tabs}
                >
                  <Tab label={`Success (${invoiceStats?.successInvoices ?? 0})`} />
                  <Tab label={`Pending (${invoiceStats?.pendingInvoices ?? 0})`} />
                </Tabs>

                <Box className={classes.tabPanel}>
                  <TabPanel value={tabValue} index={0}>
                    {renderStatusTable("SUCCESS")}
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    {renderStatusTable("PENDING")}
                  </TabPanel>
                </Box>
              </Box>
            )}
          </Box>
        </Fade>
      </Container>
    </Box>
  );
}
